<template>
  <div id='bd-message'>
    <!-- TODO: 仅能向下加载更多，增加上拉加载更多 -->
    <!-- TODO: 识别文本中URL，可直接点击打开新网页 -->
    <el-empty v-if="blockMessages.length === 0" description="暂无消息"></el-empty>
    <ul class="bd-message-ul" ref="list">
      <!-- <div v-if="userCurrentThread.id !== 0 && !userCurrentThread.last" class="pullrefresh" @click="getMoreMessages()">{{ $t('moreMessage') }}</div> -->
      <li v-for="message in blockMessages" :key="message.mid">

        <p class="timestamp">
          <span>{{ message.createdAt | datetime }}</span><br/>
          <span v-if="is_type_notification_agent_close(message)">{{ agentCloseThreadTip }}</span>
          <span v-else-if="is_type_notification_visitor_close(message)">{{ visitorCloseThreadTip }}</span>
          <span v-else-if="is_type_notification_auto_close(message)">{{ autoCloseThreadTip }}</span>
          <span v-else-if="is_type_notification_thread_reentry(message)">{{ threadReentryTip }}</span>
          <span v-else-if="is_type_notification_connect(message)">{{ visitorConnectTip }}</span>
          <span v-else-if="is_type_notification_disconnect(message)">{{ visitorDisconnectTip }}</span>
          <span v-else-if="is_type_notification_offline(message)">{{ agentOfflineTip }}</span>
          <span v-else-if="is_type_notification_invite_rate(message)">{{ inviteRateTip }}</span>
          <span v-else-if="is_type_notification_rate_result(message)">{{ rateResultTip }}</span>
          <span v-else-if="is_type_notification(message)">{{ message.content }}</span>
        </p>

        <div v-if="!is_type_notification(message)" class="main" :class="{ self: is_self(message) }">
          <img v-if="show_header" class="avatar" width="30" height="30"
            :src="message.user.avatar"
            @click="imageClicked(message.user.avatar)" alt="image"/>
          <!-- <el-avatar v-if="show_header" class="avatar" size="medium"
              :src="message.user.avatar"
              @click="imageClicked(message.user.avatar)">
            </el-avatar> -->
          <div v-if="!is_self(message)" class="nickname">{{ message.user.nickname }}{{ from_client(message) }}</div>
          <!-- TODO: 点击消息内容，弹窗用户选择：复制消息内容 or 撤回消息(3分钟之内) -->
          <div v-if="is_type_text(message)" class="text" v-html="replaceFace(message.content)"
            @click="textClicked(message)"
            @click.right="rightEvent(message)"
            @contextmenu.prevent="onContextmenu"></div>
          <!-- 暂不显示机器人消息 -->
          <div v-if="is_type_robot(message)" class="text" v-html="replaceFace(message.content)"></div>
          <div v-if="is_type_questionnaire(message)" class="text">
            <span>{{ message.questionnaire.questionnaireItems[0].title }}</span>
            <span v-for="item in message.questionnaire.questionnaireItems[0].questionnaireItemItems" :key="item.id">
              <br/>
              <span style="color:#007bff; cursor: pointer;">{{ item.content }}</span>
            </span>
          </div>
          <div v-if="is_type_company(message)" class="text">
            <span>{{ message.content }}</span>
            <span v-for="item in message.company.countries" :key="item.cid">
              <br/>
              <span style="color:#007bff; cursor: pointer;">{{ item.name }}</span>
            </span>
          </div>
          <div v-if="is_type_workGroup(message)" class="text">
            <span>{{ message.content }}</span>
            <span v-for="item in message.workGroups" :key="item.wid">
              <br/>
              <span style="color:#007bff; cursor: pointer;">{{ item.nickname }}</span>
            </span>
          </div>
          <div v-if="is_type_image(message)" class="text" @click.right="rightEvent(message)" @contextmenu.prevent="onContextmenu">
            <!-- FIXME: 预览时，非默认展示当前图片 :preview-src-list="previewImageSrcList" -->
            <el-image style="padding-top: 10px; width: 100px; height: 100px;"
              :src="message.imageUrl"
              :preview-src-list="[message.imageUrl]" lazy/>
          </div>
          <div v-if="is_type_file(message)" class="text" @click.right="rightEvent(message)" @contextmenu.prevent="onContextmenu">
            <img src="https://cdn.bytedesk.com/img/input/file.png" alt="[文件]"
              style="padding-top: 10px; padding-bottom: 10px; width: 25px; height: 25px;"
              @click="fileClicked(message.fileUrl)"/>
            <span><a :href="message.fileUrl" target="_blank">{{ $t('viewFile') }}</a></span>
          </div>
          <div v-if="is_type_voice(message)" class="text" @click.right="rightEvent(message)" @contextmenu.prevent="onContextmenu">
            <img src="https://cdn.bytedesk.com/img/input/voice_received.png" alt="[语音]"
              style="padding-top: 10px; padding-bottom: 10px; width: 25px; height: 20px;"
              @click="voiceClicked(message.voiceUrl)"/>
          </div>
          <div v-if="is_type_video(message)" class="text" @click.right="rightEvent(message)" @contextmenu.prevent="onContextmenu">
            <span><a :href="message.videoOrShortUrl" target="_blank">{{ $t('viewVideo') }}</a></span>
          </div>

          <!-- TODO: 以下类型有待格式化显示 -->
          <div v-if="is_type_location(message)" class="text">{{ message.label }}</div>
          <div v-if="is_type_link(message)" class="text">{{ message.title }}</div>
          <div v-if="is_type_event(message)" class="text">{{ message.content }}</div>
          <div v-if="is_type_custom(message)" class="text">{{ message.content }}</div>
          <!-- TODO: 表单待完善 -->
          <div v-if="is_type_form_request(message)" class="text">请求表单</div>
          <div v-if="is_type_form_result(message)" class="text">
            <div v-if="formObject(message.content).form.realname.trim().length > 0">姓名：{{ formObject(message.content).form.realname }}</div>
            <div v-if="formObject(message.content).form.mobile.trim().length > 0">手机：{{ formObject(message.content).form.mobile }}</div>
            <div v-if="formObject(message.content).form.email.trim().length > 0">邮箱：{{ formObject(message.content).form.email }}</div>
            <div v-if="formObject(message.content).form.age > 0">年龄：{{ formObject(message.content).form.age }}</div>
            <div v-if="formObject(message.content).form.job.trim().length > 0">职业：{{ formObject(message.content).form.job }}</div>
          </div>
          <div v-if="is_type_red_packet(message)" class="text">{{ message.content }}</div>
          <div v-if="is_type_commodity(message)" class="text">
            <div>唯一id: {{ jsonObject(message.content).id }}</div>
            <div>类别码: {{ jsonObject(message.content).categoryCode }}</div>
            <div>价格: {{ jsonObject(message.content).price }}</div>
            <div>标题: {{ jsonObject(message.content).title }}</div>
            <div>详情: {{ jsonObject(message.content).content }}</div>
            <div><a style="color:blue;" :href="jsonObject(message.content).url" target="_blank">{{ $t('link') }}</a></div>
            <div>
              <a style="color:blue;" :href="jsonObject(message.content).url" target="_blank">
                <img :src="jsonObject(message.content).imageUrl" style="width: 50px; height:50px;"/>
              </a>
            </div>
          </div>

          <div v-if="is_self(message)" class="status" >
              <i v-if="is_sending(message)" class="el-icon-loading" style="font-size:10px"></i>
              <i v-if="is_stored(message)" class="fa fa-times-circle" style="font-size:10px"></i>
              <i v-if="is_received(message)" style="font-size:10px; margin-right: 5px;">{{ $t('received') }}</i>
              <i v-if="is_read(message)" style="font-size:10px; margin-right: 5px;">{{ $t('read') }}</i>
              <i v-if="is_error(message)" class="iconfont icon-error" style="font-size:10px"></i>
              <i v-if="can_recall(message)" class="el-icon-delete" @click="recallButtonClicked(message)"></i>
          </div>

        </div>
      </li>
    </ul>
    <!-- <p v-if="loadingMoreMessage">加载中...</p>
    <p v-if="noMoreMessage">没有更多了</p> -->

    <el-dialog title="查看大图" :modal="false" :visible.sync="imageDialogVisible" width="40%" :before-close="handleImageDialogClose">
      <span><img id="currentImage" :src="currentImageUrl" alt="[查看大图]" style="width: 100%; height: 100%;"/></span>
      <span slot="footer" class="dialog-footer">
        <!-- TODO: 增加复制网址、旋转、下载图片 -->
        <!-- <el-button v-if="electron && showAuthority.debug" @click="downloadImage">下载</el-button> -->
        <!-- <el-button @click="transformLarger">放大</el-button> -->
        <!-- <el-button @click="transformSmaller">缩小</el-button> -->
        <!-- <el-button @click="transformLeft">左旋转</el-button> -->
        <!-- <el-button @click="transformRight">右旋转</el-button> -->
        <el-button type="primary" @click="imageDialogVisible = false">{{ $t('close') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog v-dialogDrag
      title="提示"
      :visible.sync="recallDialogVisible"
      width="30%"
      center>
      <span>确定要撤回信息:{{ recallMessage.content }}?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="recallDialogVisible = false">{{ $t('cancel') }}</el-button>
        <el-button type="primary" @click="doRecallMessage">{{ $t('ok') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog title="语音播放器" :modal="false" width="30%" :visible.sync="dialogTableVisible" center>
      <!-- http://wuxieyun.com/opencore-amr-js/js/index.php?url=http://kefudashi.oss-cn-hangzhou.aliyuncs.com/voice/NkChHr9aE832V7iGtPBj37RmtPhzloHGopn8bE0gJsccf-zjj4bJlFBCv_qnszmr.amr -->
      <iframe :src="player_url"></iframe>
    </el-dialog>

  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import * as constants from '@/util/constants'
import bus from '@/util/eventbus'

export default {
  name: 'bd-message',
  data () {
    return {
      imageDialogVisible: false,
      recallMessage: {
        mid: '',
        content: ''
      },
      recallDialogVisible: false,
      currentImageUrl: '',
      currentVoiceUrl: '',
      dialogTableVisible: false,
      emojiBaseUrl: constants.EMOJI_BASE_URL,
      electron: constants.IS_ELECTRON,
      transformDegree: 0,
      visible: false,
      //
      // count: 10,
      currentPage: 1,
      pageSize: 100,
      loadingMoreMessage: false
    }
  },
  computed: {
    // 'messages',
    ...mapGetters([ 'userInfo', 'userCurrentThread', 'userCurrentContact',
      'userCurrentGroup', 'blockMessages', 'showAuthority' ]),
    ...mapState([
      'emotionMap', 'emotionWxMap'
    ]),
    disabled () {
      return this.userCurrentThread.id === 0
    },
    show_header () {
      return true
    },
    noMoreMessage () {
      return this.userCurrentThread.last
    },
    previewImageSrcList () {
      let previewImageSrcList = []
      for (let i = 0; i < this.blockMessages.length; i++) {
        const element = this.blockMessages[i]
        if (element.type === constants.MESSAGE_TYPE_IMAGE) {
          previewImageSrcList.push(element.imageUrl)
        }
      }
      return previewImageSrcList
    },
    //
    agentCloseThreadTip () {
      return this.$t('agentCloseThread')
    },
    visitorCloseThreadTip () {
      return this.$t('visitorCloseThread')
    },
    autoCloseThreadTip () {
      return this.$t('autoCloseThread')
    },
    threadReentryTip () {
      return this.$t('threadReentry')
    },
    visitorConnectTip () {
      return this.$t('visitorConnect')
    },
    visitorDisconnectTip () {
      return this.$t('visitorDisconnect')
    },
    agentOfflineTip () {
      return this.$t('agentOffline')
    },
    inviteRateTip () {
      return this.$t('inviteRate')
    },
    rateResultTip () {
      return this.$t('rateResult')
    }
  },
  methods: {
    ...mapActions([ 'getMessages' ]),
    // ...mapActions('stomp', [ 'sendRecallMessage' ]),
    ...mapActions('mqtt', [ 'sendMessageProtobuf' ]),
    jsonObject (content) {
      return content === null ? '{"categoryCode":"","content":"","id":0,"imageUrl":"","price":"","title":"","type":"commodity","url":""}' : JSON.parse(content)
    },
    formObject (content) {
      return content === null ? '{"form":{"realname":"test1","mobile":"13311158888","email":"","age":0,"job":""}}' : JSON.parse(content)
    },
    getMoreMessages () {
      // https://element.eleme.cn/#/zh-CN/component/loading
      const loading = this.$loading({
        // target: 'bd-message',
        lock: false,
        fullscreen: false,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      // TODO: 后期修改为真实加载时长
      setTimeout(() => {
        loading.close()
      }, 2000)
      // 加载
      let payload = { page: this.currentPage, size: this.pageSize, scroll: false }
      this.getMessages(payload)
      this.currentPage += 1
    },
    textClicked (message) {
      console.log('text clicked:', message.mid, message.content)
      this.copyToClip(message.content)
      this.$message('"' + message.content + '" ' + this.$t('copiedToClip'));
      // 3分钟之内允许撤回
      // if (this.can_recall(message)) {
      //   this.recallMessage = message
      //   this.recallDialogVisible = true
      // }
    },
    recallButtonClicked (message) {
      console.log('text clicked:', message.mid, message.content)
      // 3分钟之内允许撤回
      if (this.can_recall(message)) {
        this.recallMessage = message
        this.recallDialogVisible = true
      }
    },
    imageClicked (imageUrl) {
      // console.log('image clicked:', imageUrl)
      this.currentImageUrl = imageUrl
      this.imageDialogVisible = true
    },
    fileClicked (fileUrl) {
      if (this.electron) {
        ipcRenderer.send('open-external-url', fileUrl)
      } else {
        window.open(fileUrl)
      }
    },
    voiceClicked (voiceUrl) {
      // console.log('voice clicked:', voiceUrl)
      this.currentVoiceUrl = voiceUrl
      // this.dialogTableVisible = true
      window.open(voiceUrl)
    },
    transformLarger () {
      console.log('transformLarger')
      let currentImage = document.getElementById('currentImage')
      currentImage.width = currentImage.width * 1.1
      currentImage.height = currentImage.height * 1.1
    },
    transformSmaller () {
      console.log('transformSmaller')
      let currentImage = document.getElementById('currentImage')
      currentImage.width = currentImage.width * 0.9
      currentImage.height = currentImage.height * 0.9
    },
    transformLeft () {
      this.transformDegree -= 90
      document.getElementById('currentImage').style.transform = 'rotate(' + this.transformDegree + 'deg)'
    },
    transformRight () {
      this.transformDegree += 90
      document.getElementById('currentImage').style.transform = 'rotate(' + this.transformDegree + 'deg)'
    },
    downloadImage () {
      console.log('downloadImage:', this.currentImageUrl)
      ipcRenderer.send('save-image-dialog', this.currentImageUrl)
    },
    is_self (message) {
      // return !message.user.visitor
      return message.client === constants.CLIENT_SYSTEM || message.user.uid === this.userInfo.uid
    },
    // 发送状态
    is_sending (message) {
      return message.status === constants.MESSAGE_STATUS_SENDING
    },
    is_stored (message) {
      return message.status === constants.MESSAGE_STATUS_STORED
    },
    is_received (message) {
      return message.status === constants.MESSAGE_STATUS_RECEIVED
    },
    is_error (message) {
      return message.status === constants.MESSAGE_STATUS_ERROR
    },
    is_read (message) {
      return message.status === constants.MESSAGE_STATUS_READ
    },
    can_recall (message) {
      return this.callRecallMessage(message) &&
        this.is_self(message) &&
        (message.type === constants.MESSAGE_TYPE_TEXT || message.type === constants.MESSAGE_TYPE_IMAGE)
    },
    // 消息类型
    is_type_text (message) {
      return message.type === constants.MESSAGE_TYPE_TEXT ||
      message.type === constants.MESSAGE_TYPE_NOTIFICATION_THREAD
    },
    is_type_robot (message) {
      // 大学长隐藏 机器人消息
      return message.type === constants.MESSAGE_TYPE_ROBOT
    },
    is_type_image (message) {
      return message.type === constants.MESSAGE_TYPE_IMAGE
    },
    is_type_file (message) {
      return message.type === constants.MESSAGE_TYPE_FILE
    },
    is_type_voice (message) {
      return message.type === constants.MESSAGE_TYPE_VOICE
    },
    is_type_video (message) {
      return message.type === constants.MESSAGE_TYPE_VIDEO || message.type === constants.MESSAGE_TYPE_SHORT_VIDEO
    },
    // is_type_shortvideo (message) {
    //   return message.type === constants.MESSAGE_TYPE_SHORT_VIDEO
    // },
    is_type_location (message) {
      return message.type === constants.MESSAGE_TYPE_LOCATION
    },
    is_type_link (message) {
      return message.type === constants.MESSAGE_TYPE_LINK
    },
    is_type_event (message) {
      return message.type === constants.MESSAGE_TYPE_EVENT
    },
    is_type_custom (message) {
      return message.type === constants.MESSAGE_TYPE_CUSTOM
    },
    is_type_red_packet (message) {
      return message.type === constants.MESSAGE_TYPE_RED_PACKET
    },
    is_type_commodity (message) {
      return message.type === constants.MESSAGE_TYPE_COMMODITY
    },
    is_type_questionnaire (message) {
      return message.type === constants.MESSAGE_TYPE_QUESTIONNAIRE
    },
    is_type_company (message) {
      return message.type === constants.MESSAGE_TYPE_COMPANY
    },
    is_type_workGroup (message) {
      return message.type === constants.MESSAGE_TYPE_WORK_GROUP
    },
    is_type_notification (message) {
      return message.type !== constants.MESSAGE_TYPE_NOTIFICATION_THREAD &&
      message.type !== constants.MESSAGE_TYPE_NOTIFICATION_FORM_REQUEST &&
      message.type !== constants.MESSAGE_TYPE_NOTIFICATION_FORM_RESULT &&
      message.type.startsWith(constants.MESSAGE_TYPE_NOTIFICATION)
    },
    is_type_notification_agent_close (message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_AGENT_CLOSE
    },
    is_type_notification_visitor_close (message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_VISITOR_CLOSE
    },
    is_type_notification_auto_close (message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_AUTO_CLOSE
    },
    is_type_notification_thread_reentry (message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_THREAD_REENTRY
    },
    is_type_notification_connect (message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_CONNECT
    },
    is_type_notification_disconnect (message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_DISCONNECT
    },
    is_type_notification_offline (message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_OFFLINE
    },
    is_type_notification_invite_rate (message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_INVITE_RATE
    },
    is_type_notification_rate_result (message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_RATE_RESULT
    },
    is_type_form_request (message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_FORM_REQUEST
    },
    is_type_form_result (message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_FORM_RESULT
    },
    from_client (message) {
      let client = message.client
      if (message.client.startsWith('web')) {
        client = 'web'
      } else if (message.client.startsWith('android')) {
        client = 'android'
      } else if (message.client.startsWith('ios')) {
        client = 'ios'
      }
      return '[' + client + ']'
    },
    player_url () {
      return constants.VOICE_PLAYER_BASE_URL + this.currentVoiceUrl
    },
    //  在发送信息之后，将输入的内容中属于表情的部分替换成emoji图片标签
    //  再经过v-html 渲染成真正的图片
    // TODO: 解析微信表情
    replaceFace (content) {
      if (content == null || content === undefined) {
        return content
      }
      var wxConttent = this.replaceWeChatFace(content)
      var emotionMap = this.emotionMap
      var reg = /\[[\u4E00-\u9FA5NoOK]+\]/g
      var matchresult = wxConttent.match(reg)
      var result = wxConttent
      if (matchresult) {
        for (var i = 0; i < matchresult.length; i++) {
          result = result.replace(matchresult[i], '<img height=\'25px\' width=\'25px\' style=\'margin-bottom:4px;\' src=\'' + this.emojiBaseUrl + emotionMap[matchresult[i]] + '\'>')
        }
      }
      return result
    },
    replaceWeChatFace (content) {
      if (content == null || content === undefined) {
        return content
      }
      // setPattern("/::\\)|/::~|/::B|/::\\||/:8-\\)|/::<|/::\\$|/::X|/::Z|/::'\\(|/::-\\||/::@|/::P|/::D|/::O|/::\\(|/::\\+|/:--b|/::Q|/::T|/:,@P|/:,@-D|/::d|/:,@o|/::g|/:\\|-\\)|/::!|/::L|/::>|/::,@|/:,@f|/::-S|/:\\?|/:,@x|/:,@@|/::8|/:,@!|/:!!!|/:xx|/:bye|/:wipe|/:dig|/:handclap|/:&-\\(|/:B-\\)|/:<@|/:@>|/::-O|/:>-\\||/:P-\\(|/::'\\||/:X-\\)|/::\\*|/:@x|/:8\\*|/:pd|/:<W>|/:beer|/:basketb|/:oo|/:coffee|/:eat|/:pig|/:rose|/:fade|/:showlove|/:heart|/:break|/:cake|/:li|/:bome|/:kn|/:footb|/:ladybug|/:shit|/:moon|/:sun|/:gift|/:hug|/:strong|/:weak|/:share|/:v|/:@\\)|/:jj|/:@@|/:bad|/:lvu|/:no|/:ok|/:love|/:<L>|/:jump|/:shake|/:<O>|/:circle|/:kotow|/:turn|/:skip|/:oY|/:#-0|/:hiphot|/:kiss|/:<&|/:&>");
      var emotionMap = this.emotionWxMap
      var reg = /\/::\)|\/::~|\/::B|\/::\||\/:8-\)|\/::<|\/::\$|\/::X|\/::Z|\/::'\\(|\/::-\||\/::@|\/::P|\/::D|\/::O|\/::\\(|\/::\+|\/:--b|\/::Q|\/::T|\/:,@P|\/:,@-D|\/::d|\/:,@o|\/::g|\/:\\|-\\)|\/::!|\/::L|\/::>|\/::,@|\/:,@f|\/::-S|\/:\\?|\/:,@x|\/:,@@|\/::8|\/:,@!|\/:!!!|\/:xx|\/:bye|\/:wipe|\/:dig|\/:handclap|\/:&-\\(|\/:B-\\)|\/:<@|\/:@>|\/::-O|\/:>-\\||\/:P-\\(|\/::'\\||\/:X-\\)|\/::\\*|\/:@x|\/:8\\*|\/:pd|\/:<W>|\/:beer|\/:basketb|\/:oo|\/:coffee|\/:eat|\/:pig|\/:rose|\/:fade|\/:showlove|\/:heart|\/:break|\/:cake|\/:li|\/:bome|\/:kn|\/:footb|\/:ladybug|\/:shit|\/:moon|\/:sun|\/:gift|\/:hug|\/:strong|\/:weak|\/:share|\/:v|\/:@\\)|\/:jj|\/:@@|\/:bad|\/:lvu|\/:no|\/:ok|\/:love|\/:<L>|\/:jump|\/:shake|\/:<O>|\/:circle|\/:kotow|\/:turn|\/:skip|\/:oY|\/:#-0|\/:hiphot|\/:kiss|\/:<&|\/:&>/g
      var matchresult = content.match(reg)
      var result = content
      if (matchresult) {
        for (var i = 0; i < matchresult.length; i++) {
          result = result.replace(matchresult[i], '<img height=\'25px\' width=\'25px\' style=\'margin-bottom:4px;\' src=\'' + this.emojiBaseUrl + emotionMap[matchresult[i]] + '\'>')
        }
      }
      return result
    },
    handleImageDialogClose (done) {
      done()
    },
    scrollToBottom () {
      // 聊天记录滚动到最底部
      let vm = this
      this.$nextTick(() => {
        const ul = vm.$refs.list
        if (ul != null) {
          ul.scrollTop = ul.scrollHeight
        }
      })
    },
    // 撤回消息
    doRecallMessage () {
      this.recallDialogVisible = false
      // console.log('recallMessage:', this.recallMessage.mid, this.recallMessage.content)
      //
      let payload = { type: constants.MESSAGE_TYPE_NOTIFICATION_RECALL, content: this.recallMessage.mid, thread: this.userCurrentThread }
      this.sendMessageProtobuf(payload)
      // let payload = { mid: this.recallMessage.mid }
      // this.sendRecallMessage(payload)
    },
    // 检测是否在3分钟之内，允许撤回消息
    callRecallMessage (message) {
      let now = moment(new Date(), 'YYYY-MM-DD HH:mm:ss')
      let createdAt = moment(message.createdAt, 'YYYY-MM-DD HH:mm:ss')
      let seconds = now.diff(createdAt, 'seconds')
      // 现在距消息发送的时间差
      // console.log('seconds passed: ', seconds)
      if (seconds < 180) {
        return true
      }
      return false
    },
    // 鼠标右键
    rightEvent (message) {
      // console.log('点击右键', message)
      this.rightClickMessage = message
    },
    // 引用第三方组件: https://github.com/GitHub-Laziji/menujs
    onContextmenu (event) {
      this.$contextmenu({
        items: [
          {
            label: this.$t('copy'),
            icon: 'el-icon-copy-document',
            onClick: () => {
              if (this.is_type_text(this.rightClickMessage)) {
                this.copyToClip(this.rightClickMessage.content)
                this.$message('"' + this.rightClickMessage.content + '" ' + this.$t('copiedToClip'));
              } else if (this.is_type_image(this.rightClickMessage)) {
                this.copyToClip(this.rightClickMessage.imageUrl)
                this.$message('"' + this.rightClickMessage.imageUrl + '" ' + this.$t('copiedToClip'));
              } else if (this.is_type_file(this.rightClickMessage)) {
                this.copyToClip(this.rightClickMessage.fileUrl)
                this.$message('"' + this.rightClickMessage.fileUrl + '" ' + this.$t('copiedToClip'));
              } else if (this.is_type_voice(this.rightClickMessage)) {
                this.copyToClip(this.rightClickMessage.voiceUrl)
                this.$message('"' + this.rightClickMessage.voiceUrl + '" ' + this.$t('copiedToClip'));
              } else if (this.is_type_video(this.rightClickMessage)) {
                this.copyToClip(this.rightClickMessage.videoOrShortUrl)
                this.$message('"' + this.rightClickMessage.videoOrShortUrl + '" ' + this.$t('copiedToClip'));
              }
            }
          }
        ],
        event,
        customClass: 'class-a',
        zIndex: 3,
        minWidth: 230
      })
      return false
    },
    copyToClip(content) {
      var aux = document.createElement("input"); 
      aux.setAttribute("value", content); 
      document.body.appendChild(aux); 
      aux.select();
      document.execCommand("copy"); 
      document.body.removeChild(aux);
    },
    // 加载更多
    loadMoreMessage () {
      console.log('loadMoreMessage')
      //
      // this.loadingMoreMessage = true
      // setTimeout(() => {
      //   this.count += 2
      //   this.loadingMoreMessage = false
      // }, 100)
    }
  },
  mounted () {
    // 通知界面滚动到底部
    bus.$on(constants.EVENT_BUS_MESSAGE_SCROLL_TO_BOTTOM, () => {
      // console.log('scroll to bottom')
      let vm = this
      vm.$nextTick(() => {
        const ul = vm.$refs.list
        if (ul != null) {
          ul.scrollTop = ul.scrollHeight
        }
      })
    })
  },
  filters: {
    datetime (value) {
      if (typeof value === 'string') {
        return moment(value).format('YYYY-MM-DD HH:mm:ss')
      } else {
        return value
      }
    }
  }
}
</script>

<style scoped>
.pullrefresh {
  margin-top: 20px;
  text-align: center;
  font-size: 10px;
  color: blue;
  cursor: pointer;
}
#bd-message {
  /* width: calc(100% - 20px); */
  /* height: calc(100% - 200px); */
  width: 100%;
  height: 100%;
  margin-left: 5px;
  margin-right: 5px;
  /* padding-left: 10px; */
  /* padding-bottom: 20px; */
  overflow-y: scroll;
}
.bd-message-ul {
  /* border: 1px solid #ccf; */
  font-size: 16px;
  height: 100%;
  /* margin: 0; */
  margin-left: 0px;
  margin-top: 0px;
  /* margin-bottom: 10px; */
  /* padding-bottom: 10px; */
  overflow-y: auto;
  padding: 0;
}
li {
  margin-bottom: 15px;
  clear: both;
}
.main {
  margin-left: 0px;
}
.timestamp {
  margin: 10px 0;
  text-align: center;
  font-size: 10px;
}
.timestamp span {
  display: inline-block;
  padding: 0 8px;
  /* color: #fff; */
  border-radius: 5px;
  color: #bbbbbb;
}
.avatar {
  float: left;
  margin: 0 10px 0 0;
  border-radius: 3px;
}
.nickname {
  text-align: left;
  font-size: 10px;
}
.text {
  float: left;
  position: relative;
  padding: 2px 10px 0px;
  max-width: calc(100% - 250px);
  min-height: 30px;
  line-height: 2.5;
  font-size: 12px;
  text-align: left;
  word-break: break-all;
  background-color: #dddddd;
  border-radius: 4px;
}
.text:before {
  content: " ";
  position: absolute;
  top: 9px;
  right: 100%;
  border: 6px solid transparent;
  border-right-color: #dddddd;
}
.self {
  text-align: right;
}
.self .avatar {
  float: right;
  margin: 0 0 0 10px;
}
.self .nickname {
  text-align: right;
  font-size: 10px;
}
.self .text {
  float: right;
  background-color: #b2e281;
}
.self .text:before {
  right: inherit;
  left: 100%;
  border-right-color: transparent;
  border-left-color: #b2e281;
}
.self .status {
  float: right;
  margin-right: 8px;
}
.notification {
  text-align: center;
}
.chat li {
  border: none;
}
</style>
